// extracted by mini-css-extract-plugin
module.exports = {"content":"content___1a901","close":"close___g9pce"};